<div class="gpd-full-page">
  <dx-data-grid
    #masterGrid
    id="masterGrid"
    [dataSource]="propertyOwners"
    (onSelectionChanged)="selectionChanged($event)"
    showRowLines="true"
    (onRowExpanding)="onMasterRowExpanding($event)"
    [allowColumnResizing]="true"
    how ="'widget'"
    [columnAutoWidth]="false"
    [showBorders]="true"
    [scrolling]="{ mode: 'standard', useNative: true }"
    [width]="'100%'"
    height="100%"
    class="gt-data-grid-style"
    [rowAlternationEnabled]="true"
    [hoverStateEnabled]="true"
  >
    <dxo-toolbar>
      <dxi-item width="50%" location="before">
        <dx-text-box
          [(value)]="searchTerm"
          mode="search"
          valueChangeEvent="keyup"
          width="350px"
          class="custom-search-panel"
          (onValueChanged)="masterGrid.instance.searchByText($event.value)"
          i18n-placeholder="@@propertiesSearch"
          placeholder="Search properties..."
        ></dx-text-box>
      </dxi-item>
      <dxi-item width="50%">
        <div class="gt-flex-dir-row" style="gap: 8px">
          <app-gpd-button
            *ngIf="fillTemplateEnabled"
            type="secondary"
            i18n-text="@@fillTemplate"
            text="Fill in template"
            icon="document"
            [disabled]="fillTemplateEligibleOwners === 0"
            (onClick)="openFillTemplate()"
          >
          </app-gpd-button>
          <app-gpd-button
            i18n-text="@@addEntry"
            text="New entry"
            *ngIf="editMode"
            icon="add"
            (onClick)="contactsPopupVisible = true"
          >
          </app-gpd-button>
        </div>
      </dxi-item>
    </dxo-toolbar>

    <dxi-column dataField="name" cellTemplate="cellTemplate">
      <div *dxTemplate="let item of 'cellTemplate'">
        <div class="cell-with-buttons">
          <span>{{ item.data.name }}</span>
          <div class="cell-button-container">
            <app-gpd-button
              *ngIf="editMode"
              type="text"
              icon="user-switch"
              i18n-hint="@@replaceOwnerHint"
              hint="Replace person"
              (onClick)="showReplaceOwnerPopup(item.data)"
            ></app-gpd-button>
            <app-gpd-button
              type="text"
              icon="user"
              (onClick)="
                jumpToContactDetails(item.data.contactType, item.data.contactId)
              "
            ></app-gpd-button>
          </div>
        </div>
      </div>
    </dxi-column>

    <dxi-column
      dataField
      [visible]="editMode"
      allowEditing=" false"
      cellTemplate="buttonCellTemplate"
      [width]="34"
    >
      <div
        class="cell-with-buttons"
        *dxTemplate="let item of 'buttonCellTemplate'"
      >
        <div class="cell-button-container">
          <app-gpd-button
            type="text"
            icon="cancel"
            (onClick)="
              initDeletionPropertyOwner(
                item.data,
                'Do you want to remove this property owner and all properties from the list?'
              )
            "
          ></app-gpd-button>
        </div>
      </div>
    </dxi-column>

    <dxo-master-detail
      [enabled]="true"
      template="PropertyOwners"
    ></dxo-master-detail>
    <div *dxTemplate="let propertyOwner of 'PropertyOwners'">
      <dx-tab-panel
        #tabview
        [(selectedIndex)]="selectedTabIndex"
        repaintChangesOnly="true"
      >
        <dxi-item
          i18n-title="@@properties"
          title="Properties"
          template="propertiesTab"
        >
          <div *dxTemplate="let properties of 'propertiesTab'">
            <dx-data-grid
              [id]="
                propertyOwner.data.contactType +
                '_' +
                propertyOwner.data.contactId
              "
              [keyExpr]="propertyOwner.data.properties.propertyId"
              [dataSource]="propertyOwner.data.properties"
              (onRowInserted)="onPropertyRowInserted($event)"
              (onSaved)="onPropertyRowUpdated($event)"
              (onEditCanceling)="onEditCanceling()"
              (onEditorPreparing)="onEditorPrepared($event)"
              (onEditingStart)="onEditingStart($event)"
              [repaintChangesOnly]="true"
              (onCellDblClick)="showContract($event, propertyOwner.data)"
              [editing]="{
                mode: 'form',
                texts: {
                  saveRowChanges: confirmText,
                  cancelRowChanges: cancelText
                }
              }"
              showRowLines="true"
              [repaintChangesOnly]="true"
              [allowColumnResizing]="true"
              [columnResizingMode]="'widget'"
              [columnAutoWidth]="false"
              [showBorders]="true"
              [scrolling]="{ mode: 'standard', useNative: true }"
              [width]="'100%'"
              class="gt-data-grid-style"
              [rowAlternationEnabled]="true"
              [hoverStateEnabled]="true"
            >
              <dxo-toolbar>
                <dxi-item width="50%">
                  <div class="btnRow gt-flex-dir-row">
                    <app-gpd-button
                      i18n-text="@@addNewProperty"
                      text="ADD NEW PROPERTY"
                      icon="add"
                      (onClick)="
                        addRow(
                          propertyOwner.data.contactType +
                            '_' +
                            propertyOwner.data.contactId
                        )
                      "
                    >
                    </app-gpd-button>
                  </div>
                </dxi-item>
              </dxo-toolbar>

              <dxi-column
                dataField="localCourt"
                i18n-caption="@@localCourt"
                caption="Local Court"
                [editorOptions]="{ maxLength: 50 }"
              >
                <dxo-form-item>
                  <dxi-validation-rule type="required"> </dxi-validation-rule>
                </dxo-form-item>
              </dxi-column>

              <dxi-column
                dataField="sheet"
                i18n-caption="@@sheet"
                caption="Sheet"
                [editorOptions]="{ maxLength: 50 }"
              >
                <dxi-validation-rule type="required"></dxi-validation-rule>
              </dxi-column>

              <dxi-column
                dataField="district"
                i18n-caption="@@district"
                [editorOptions]="{ maxLength: 50 }"
                caption="District"
                ><dxi-validation-rule type="required"></dxi-validation-rule
              ></dxi-column>
              <dxi-column
                dataField="hallway"
                i18n-caption="@@hallway"
                [editorOptions]="{ maxLength: 50 }"
                caption="Hallway"
                ><dxi-validation-rule type="required"></dxi-validation-rule
              ></dxi-column>
              <dxi-column
                dataField="parcel"
                i18n-caption="@@parcel"
                caption="Parcel"
                [editorOptions]="{ maxLength: 50 }"
                ><dxi-validation-rule type="required"></dxi-validation-rule
              ></dxi-column>

              <dxi-column
                dataField="size"
                [caption]="sizeCaption"
                dataType="number"
              >
              </dxi-column>

              <!--  editCellTemplate=" editSizeTemplate"            <div *dxTemplate="let item of 'editSizeTemplate'">
                                    <dx-number-box [(value)]="item.size" [showSpinButtons]="false" [max]="99999999.99"
                                        (onInput)="enforceMaxLength($event, item)">
                                    </dx-number-box>
                                </div> -->

              <dxi-column dataField="areaTypeId" caption="Area Type">
                <dxo-lookup
                  [dataSource]="contractAreaTypesNew"
                  displayExpr="name"
                  valueExpr="id"
                >
                </dxo-lookup>
              </dxi-column>

              <dxi-column
                dataField="notes"
                i18n-caption="@@notes"
                caption="Notes"
                [editorOptions]="{ maxLength: 1000 }"
              >
                <dxo-form-item
                  [colSpan]="2"
                  editorType="dxTextArea"
                  [editorOptions]="{ height: 100 }"
                ></dxo-form-item>
              </dxi-column>

              <dxi-column
                dataField="registerFile"
                i18n-caption="@@registerFile"
                caption="Register File"
                width="300px"
                cellTemplate="cellTemplate"
                editCellTemplate="editCellTemplate"
              >
                <div *dxTemplate="let item of 'cellTemplate'">
                  <div
                    class="cell-with-buttons"
                    *ngIf="item.data.registerFile?.filename != null"
                  >
                    <span [title]="$safeNavigationMigration(item.data.registerFile?.filename)">
                      {{ item.data.registerFile?.filename }}
                    </span>
                    <div class="cell-button-container">
                      <dx-button
                        icon="search"
                        class="cell-button"
                        (onClick)="
                          getRegisterFileFromSharepoint(
                            $event,
                            propertyOwner.data,
                            item.data
                          )
                        "
                      ></dx-button>
                    </div>
                  </div>
                </div>
                <div *dxTemplate="let item of 'editCellTemplate'">
                  <div
                    *ngIf="item.data.registerFile?.filename == null && editMode"
                  >
                    <input
                      type="file"
                      (change)="fileChanged($event, item.data)"
                    />
                  </div>
                  <div *ngIf="item.data.registerFile?.filename != null">
                    <span>
                      {{ item.data.registerFile?.filename }}
                    </span>
                    <dx-button
                      icon="search"
                      (onClick)="
                        getRegisterFileFromSharepoint(
                          $event,
                          propertyOwner.data,
                          item.data
                        )
                      "
                    >
                    </dx-button>
                    <dx-button
                      *ngIf="editMode"
                      icon="clear"
                      (onClick)="
                        initDeleteRegisterFile(propertyOwner.data, item.data)
                      "
                    >
                    </dx-button>
                  </div>
                </div>
              </dxi-column>
              <dxi-column
                dataField
                caption="Uploaded By"
                i18n-caption="@@uploadedBy"
                caption="Uploaded By"
                cellTemplate="uploadedByCellTemplate"
                [formItem]="{ visible: false }"
              >
                <div *dxTemplate="let item of 'uploadedByCellTemplate'">
                  <span>{{ item.data.registerFile?.uploadedBy }}</span>
                </div>
              </dxi-column>
              <dxi-column
                dataField
                caption="Upload Date"
                i18n-caption="@@uploadDate"
                caption="Upload Date"
                [formItem]="{ visible: false }"
                cellTemplate="uploadDateCellTemplate"
              >
                <div *dxTemplate="let item of 'uploadDateCellTemplate'">
                  <span>{{
                    $safeNavigationMigration(item.data.registerFile?.uploadDate)
                      | date : "dd.MM.yyyy HH:mm"
                  }}</span>
                </div>
              </dxi-column>
              <dxi-column
                dataField
                [visible]="editMode"
                allowEditing="false"
                cellTemplate="buttonCellTemplate"
                [formItem]="{ visible: false }"
                [width]="68"
              >
                <div *dxTemplate="let item of 'buttonCellTemplate'">
                  <div class="cell-with-buttons">
                    <div class="cell-button-container">
                      <dx-button
                        icon="edit"
                        class="cell-button"
                        (onClick)="
                          editRow(
                            propertyOwner.data.contactType +
                              '_' +
                              propertyOwner.data.contactId,
                            item.data.propertyId
                          )
                        "
                      >
                      </dx-button>
                      <dx-button
                        icon="clear"
                        class="cell-button"
                        (onClick)="
                          initDeletionProperty(propertyOwner.data, item.data)
                        "
                      >
                      </dx-button>
                    </div>
                  </div>
                </div>
              </dxi-column>
            </dx-data-grid>
          </div>
        </dxi-item>
        <dxi-item
          i18n-title="@@documents"
          title="Documents"
          template="propertyFilesTab"
        >
          <div *dxTemplate="let c of 'propertyFilesTab'">
            <dx-data-grid
              [allowColumnResizing]="true"
              columnResizingMode="widget"
              [dataSource]="propertyOwner.data.contractFiles"
              (onSaved)="saveContract($event)"
              [id]="
                propertyOwner.data.contactType +
                '_' +
                propertyOwner.data.contactId +
                '_contracts'
              "
              (onEditCanceling)="onEditCanceling()"
              (onRowInserting)="onContractRowInserting($event)"
              (onRowInserted)="onContractRowInserted($event)"
              (onSelectionChanged)="onDocumentSelectionChanged($event, propertyOwner.data)"
              [editing]="{
                mode: 'form',
                texts: {
                  saveRowChanges: confirmText,
                  cancelRowChanges: cancelText
                }
              }"
              showRowLines="true"
              [allowColumnResizing]="true"
              [columnResizingMode]="'widget'"
              [columnAutoWidth]="false"
              [showBorders]="true"
              [scrolling]="{ mode: 'standard', useNative: true }"
              [width]="'100%'"
              class="gt-data-grid-style"
              [rowAlternationEnabled]="true"
              [hoverStateEnabled]="true"
            >
              <dxo-selection
                mode="multiple"
                showCheckBoxesMode="always"
              ></dxo-selection>

              <dxo-toolbar>
                <dxi-item width="50%">
                  <div class="btnRow gt-flex-dir-row" style="gap: 8px">
                    <app-gpd-button
                      [visible]="currentEditDetailGrid == null"
                      type="primary"
                      i18n-text="@@addNewDocument"
                      text="Add document"
                      icon="add"
                      iconColor="white"
                      (onClick)="
                        addRow(
                          propertyOwner.data.contactType +
                            '_' +
                            propertyOwner.data.contactId +
                            '_contracts'
                        )
                      "
                    ></app-gpd-button>
                    <app-gpd-button
                      *ngIf="contractsEnabled"
                      type="secondary"
                      i18n-text="@@moveDocumentsToContracts"
                      text="Move documents to contracts"
                      icon="arrow-right"
                      [disabled]="!hasSelectedDocuments(propertyOwner.data)"
                      (onClick)="moveDocumentsToContracts(propertyOwner.data)"
                    ></app-gpd-button>
                  </div>
                </dxi-item>
              </dxo-toolbar>

              <dxi-column
                i18n-caption="@@documentType"
                caption="Document Type"
                dataField="contractTypeId"
              >
                <dxo-lookup
                  [dataSource]="contractTypesNew"
                  i18n="@@documentType"
                  caption="Document Type"
                  displayExpr="name"
                  valueExpr="id"
                ></dxo-lookup>
                <dxi-validation-rule type="required"></dxi-validation-rule>
              </dxi-column>

              <dxi-column
                dataField="notes"
                i18n-caption="@@filenameAddition"
                caption="Filename Addition"
                [editorOptions]="{ maxLength: 255 }"
              >
              </dxi-column>
              <dxi-column
                dataField
                i18n-caption="@@file"
                caption="File"
                cellTemplate="cellTemplate"
                editCellTemplate="editCellTemplate"
                [formItem]="{ isRequired: true }"
              >
                <div *dxTemplate="let item of 'cellTemplate'">
                  <app-document-pill
                    *ngIf="item.data.filename != null"
                    [title]="item.data.filename"
                    [value]="{
                      id: item.data.uuid,
                      documentName: item.data.filename,
                      type: 'property-file'
                    }"
                  ></app-document-pill>
                </div>
                <div *dxTemplate="let item of 'editCellTemplate'">
                  <div *ngIf="item.data.filename == null && editMode">
                    <input
                      type="file"
                      (change)="fileChanged($event, item.data)"
                    />
                  </div>
                  <div *ngIf="item.data.filename != null" class="cell-with-buttons">
                    <app-document-pill
                      [value]="{
                        id: item.data.uuid,
                        documentName: item.data.filename,
                        type: 'property-file'
                      }"
                    ></app-document-pill>
                    <dx-button
                      *ngIf="editMode"
                      icon="clear"
                      (onClick)="
                        initDeleteRegisterFile(propertyOwner.data, item.data)
                      "
                    ></dx-button>
                  </div>
                </div>
              </dxi-column>
              <dxi-column
                dataField="uploadedBy"
                i18n-caption="@@uploadedBy"
                width="120px"
                caption="Uploaded By"
                [formItem]="{ visible: false }"
              >
              </dxi-column>
              <dxi-column
                dataField="uploadDate"
                format="dd.MM.yyyy HH:mm"
                width="150px"
                dataType="date"
                i18n-caption="@@uploadDate"
                caption="Upload Date"
                [formItem]="{ visible: false }"
              >
              </dxi-column>
              <dxi-column
                dataField
                [visible]="editMode"
                allowEditing="false"
                cellTemplate="buttonCellTemplate"
                [formItem]="{ visible: false }"
                [width]="34"
              >
                <div *dxTemplate="let item of 'buttonCellTemplate'">
                  <div class="cell-with-buttons">
                    <div class="cell-button-container">
                      <dx-button
                        icon="clear"
                        class="cell-button"
                        (onClick)="
                          initDeleteDocument(propertyOwner.data, item.data)
                        "
                      >
                      </dx-button>
                    </div>
                  </div>
                </div>
              </dxi-column>
            </dx-data-grid>
          </div>
        </dxi-item>

        <dxi-item
          i18n-title="@@contracts"
          title="Contracts"
          template="contractsTab"
          *ngIf="contractsEnabled"
        >
          <div *dxTemplate="let item of 'contractsTab'">
            <dx-data-grid [dataSource]="propertyOwner.data.contracts">
              <dxo-toolbar>
                <dxi-item width="50%">
                  <div class="btnRow gt-flex-dir-row">
                    <app-gpd-button
                      i18n-text="@@downloadContractDocuments"
                      text="Download contract documents"
                      type="text"
                      icon="download"
                      [disabled]="!propertyOwner.data.contracts?.length"
                      (onClick)="downloadAllContractsForPropertyOwner(propertyOwner.data)"
                    ></app-gpd-button>
                    <app-gpd-button
                      i18n-text="@@addContracts"
                      text="Add contract"
                      type="primary"
                      icon="add"
                      iconColor="white"
                      [visible]="editMode"
                      (onClick)="showContractSelectionPopup(propertyOwner.data)"
                    ></app-gpd-button>
                  </div>
                </dxi-item>
              </dxo-toolbar>
              <dxi-column
                i18n-caption="@@designation"
                dataField="designation"
                caption="Designation"
                cellTemplate="contractDesignationCellTemplate"
              >
                <div *dxTemplate="let item of 'contractDesignationCellTemplate'">
                  <app-contracts-pill
                    [linkType]="'contract'"
                    [content]="{ contractId: item.data.id, designation: item.data.designation }"
                  ></app-contracts-pill>
                </div>
              </dxi-column>
              <dxi-column
                dataField=""
                [visible]="editMode"
                allowEditing="false"
                cellTemplate="buttonCellTemplate"
                [formItem]="{ visible: false }"
                [width]="34"
              >
                <div *dxTemplate="let item of 'buttonCellTemplate'">
                  <div class="cell-with-buttons">
                    <div class="cell-button-container">
                      <dx-button
                        icon="clear"
                        class="cell-button"
                        (onClick)="
                          removeContract(propertyOwner.data, item.data)
                        "
                      >
                      </dx-button>
                    </div>
                  </div>
                </div>
              </dxi-column>
            </dx-data-grid>
          </div>
        </dxi-item>
      </dx-tab-panel>
    </div>
  </dx-data-grid>
</div>

<!-- <div class=" gt-bottom-page-button-container">
    <div class="gt-flex-width">
        <dx-button i18n-text=@@abortCaps text="ABORT" [visible]="editMode" (onClick)="abortChanges()"
            class="gt-button gt-tertiary gt-bottom gt-btn-left">
        </dx-button>
    </div>
    <div class="gt-flex-dir-row-rev">
        <dx-button i18n-text="@@editCaps" text="EDIT" [visible]="!editMode" (onClick)="toggleEditMode(true)"
            class="gt-button gt-primary gt-bottom gt-btn-right">
        </dx-button>
        <dx-button i18n-text="@@saveCaps" text="SAVE" [visible]="editMode" (onClick)="save()"
            class="gt-button gt-primary gt-bottom gt-btn-right">
        </dx-button>
        <dx-button i18n-text="@@addEntryCaps" text="ADD ENTRY" [visible]="editMode"
            (onClick)="contactsPopupVisible = true" class="gt-button gt-primary gt-bottom gt-btn-right">
        </dx-button>
    </div>
</div> -->

<!-- Owner: a person, a company or (feature Gesellschaften) a Gesellschaft. -->
<app-contacts-popup
  [visible]="contactsPopupVisible"
  [persons]="persons"
  [companies]="companies"
  [allowSocieties]="true"
  [title]="contactsPopupTitle"
  [excludeContactId]="$safeNavigationMigration(replaceOwnerTarget?.contactId)"
  [excludeContactType]="$safeNavigationMigration(replaceOwnerTarget?.contactType)"
  (onHiding)="contactsPopupVisible = false; resetContactsPopup()"
  (onContactSelected)="onContactSelected($event)"
  (onContactAdded)="onContactAdded($event)"
></app-contacts-popup>

<app-delete-popup
  (onAbort)="handleAbort($event)"
  (onConfirm)="handleSubmit($event)"
  [visible]="deletePopupVisible"
  [message]="deleteMessage"
></app-delete-popup>

<dx-toast
  [(visible)]="toastVisible"
  i18n-message="@@savedSuccessfully"
  message="Saved successfully"
></dx-toast>
<dx-toast
  [visible]="toastTwoVisible"
  [type]="type"
  message="{{ message }}"
  position="bottom center"
  width="fit-content"
>
</dx-toast>
<ngx-doc-viewer [url]="fileUrl" viewer="url" style="width: 100%; height: auto">
</ngx-doc-viewer>

<app-file-viewer #fileviewer></app-file-viewer>

<!-- contract popup -->
<app-contract-selector-popup
  *ngIf="contractsEnabled"
  [visible]="contractSelectorPopupVisible"
  (hidden)="contractSelectorPopupVisible = false"
  (contractSelected)="onContractSelected($event)"
  [createTo]="{ id: $safeNavigationMigration(currentPropertyOwner?.id), target: 'property owner' }"
>
</app-contract-selector-popup>

<!-- Serienbrief: one filled document per selected land owner of this site (#148 follow-up). -->
<app-fill-template-modal
  [(visible)]="fillTemplateVisible"
  context="propertyOwner"
  [gridConnectionId]="gridConnectionId"
  [owners]="fillTemplateOwners"
  [documentTypes]="contractTypesNew"
  [addToContext]="fillTemplateAddToOwner"
  (closed)="onFillTemplateClosed()"
></app-fill-template-modal>
